<template>
    <component :is="template">
        <v-responsive width="100%" height="auto" max-width="420" class="mx-auto py-40px py-md-60px">
            <v-card v-if="step == 1" elevation="0">
                <div class="pa-12px py-md-20px">
                    <v-row no-gutters align="center" class="text-center">
                        <v-col cols="12">
                            <h2 class="tit tit--sm">나누리 캐시충전</h2>
                        </v-col>
                        <v-col cols="12">
                            <span class="font-size-14 grey--text">로그인 후 캐시충전을 진행하세요</span>
                        </v-col>
                    </v-row>
                </div>
                <v-divider />

                <div class="pa-12px pa-md-20px">
                    <v-row class="row--x-small">
                        <v-col cols="12">
                            <v-text-field v-model="username" placeholder="아이디" outlined persistent-placeholder hide-details />
                        </v-col>
                        <v-col cols="12">
                            <v-password-field v-model="password" placeholder="비밀번호" outlined persistent-placeholder hide-details @keydown.enter="login" autocomplete="new-password" />
                        </v-col>
                    </v-row>
                    <v-row class="row--x-small">
                        <v-col cols="12">
                            <v-btn x-large block color="primary" :loading="loading" @click="login">로그인</v-btn>
                        </v-col>
                    </v-row>
                </div>
            </v-card>
            <v-card v-if="step == 2">
                <div class="pa-12px py-md-20px">
                    <v-row no-gutters align="center" class="text-center">
                        <v-col cols="12">
                            <h2 class="tit tit--sm">나누리 캐시충전</h2>
                        </v-col>
                        <v-col cols="12">
                            <span class="font-size-14 grey--text">{{ message }}</span>
                        </v-col>
                    </v-row>
                </div>
            </v-card>
        </v-responsive>
        <auto-block-dialog v-bind="{ username }" ref="auto-block-dialog" />
        <login-failed-count-dialog v-bind="{ username }" ref="login-failed-count-dialog" />
    </component>
</template>
<script>
import api from "@/api";
import AutoBlockDialog from "@/components/client/login/auto-block-dialog.vue";
import LoginFailedCountDialog from "@/components/client/login/login-failed-count-dialog.vue";
import VPasswordField from "@/components/plugins/vuetify/v-password-field.vue";

export default {
    components: {
        AutoBlockDialog,
        LoginFailedCountDialog,
        VPasswordField,
    },
    data() {
        return {
            step: 1,
            loading: false,

            username: null,
            password: null,

            // 나누리 충전 토큰 (외부 진입 시 query로 전달)
            token: this.$route.query.token || null,
            message: "",
        };
    },
    methods: {
        validate() {
            try {
                if (!this.username) throw new Error("아이디를 입력해주세요");
                if (!this.password) throw new Error("비밀번호를 등록해주세요");
                return true;
            } catch (error) {
                alert(error.message);
                return false;
            }
        },
        async login() {
            this.loading = true;

            try {
                if (this.validate()) {
                    await this.$store.dispatch("login", {
                        username: this.username,
                        password: this.password,
                    });

                    const { success, message } = await api.v1.nanuri.charge.post({ token: this.token });

                    this.message = message;
                    this.step = 2;
                }
            } catch (error) {
                switch (error?.response?.data?.message) {
                    case "isAutoBlock": {
                        this.$refs?.["auto-block-dialog"].open?.();
                        break;
                    }
                    case "loginFailedCount": {
                        this.$refs?.["login-failed-count-dialog"].open?.();
                        break;
                    }
                    default: {
                        alert(error?.response?.data?.message ?? error.message);
                        break;
                    }
                }
            }

            this.loading = false;
        },
    },
    computed: {
        template() {
            return () => import(`@/templates/${this.$theme.pages.login}`);
        },
    },
};
</script>

<style scoped></style>
